import * as React from "react";
import * as SRD from "@projectstorm/react-diagrams";
import {BaseWidget} from "../BaseWidget/BaseWidget";
import {BotMessageNodeModel} from "../../../../model/workflowEditor";

type BotMessageWidgetProps = {
  engine: SRD.DiagramEngine;
  node: BotMessageNodeModel;
};

const BotMessageWidget: React.FunctionComponent<BotMessageWidgetProps> = ({
  engine,
  node,
}) => {
  return (
    <>
      <BaseWidget node={node} engine={engine} backgroundColor='#4a4c4c'>
      {node.data.messages[0]}
      </BaseWidget>
    </>
  );
};

export default BotMessageWidget;